import React from 'react';
import SubProductsEditor from './sub-products-editor';

const { UI } = Mobi2Go;

UI.bind('editSubProducts', ({ products, onComplete }) => {
    const sub_product_modal = UI.ExternalModal.create(
        'product-editor-sub-product',
        <SubProductsEditor
            products={products}
            onComplete={() => {
                const retain_overlay = true;
                sub_product_modal.close(retain_overlay);
                onComplete();
            }}
            onClose={() => {
                const retain_overlay = true;
                sub_product_modal.close(retain_overlay)
            }}
            /* Between products, open and close the drawer */
            beforeProductSwitches={() => {
                return new Promise(switchProduct => {
                    switchProduct();
                });
            }}
        />,
        {
            'data-view': 'product-editor-sub-product',
            className: 'm2g-product-editor',
            fixedHeight: true,
        }
    );

    sub_product_modal.mount();
    sub_product_modal.open();
});
